module.exports = __webpack_public_path__ + "img/linkedin.f756164a.svg";